import { NewsSubscriptionForm } from '@/features/news-subscription-form/ui/news-subscription-form';

export { NewsSubscriptionForm };
